import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import logoStyles from "./logo.module.scss"

export default ({ data }) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "logo.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 20) {
            document.getElementById(
              "logo"
            ).style.cssText = `width : 80px; top: 10px`
          } else {
            document.getElementById(
              "logo"
            ).style.cssText = `width : 120px; top: 50px`
          }
        })
      }

      return (
        <div className={logoStyles.logo} id="logo">
          <Img fluid={data.file.childImageSharp.fluid} />
        </div>
      )
    }}
  />
)
